import { render, staticRenderFns } from "./AttestationPrompt.vue?vue&type=template&id=1b2de6e6&"
import script from "./AttestationPrompt.vue?vue&type=script&lang=ts&"
export * from "./AttestationPrompt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports